export default __webpack_public_path__ + "static/media/checkIcon.b90b6bd1.svg";